import { useEffect, useRef } from 'react';

const DownloadLoading = () => {
    const dialogRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const prev = document.activeElement as HTMLElement | null;
        dialogRef.current?.focus();
        return () => { prev?.focus(); };
    }, []);

    return (
        <div
        className="fixed inset-0 bg-black/30 flex items-center justify-center z-[9999]"
        role="dialog"
        aria-modal="true"
        aria-labelledby="dl-loading-title"
        aria-describedby="dl-loading-desc"
        >
        <div
            ref={dialogRef}
            tabIndex={-1}
            className="bg-white border border-gray-300 rounded-md shadow-lg p-6 w-80 outline-none"
        >
            <h2 id="dl-loading-title" className="sr-only">Preparing download</h2>
            <p
            id="dl-loading-desc"
            role="status"
            aria-live="assertive"
            aria-atomic="true"
            className="text-gray-700 font-semibold text-sm"
            >
            Creating Excel workbook…
            </p>
            <div
            className="mt-4 loading-spinner-small"
            role="progressbar"
            aria-valuetext="In progress"
            />
        </div>
        </div>
    );
};

export default DownloadLoading;